var church = {
	data () {
		return {
			listChurchs: [],
			searchingChurch: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllChurchs() {
			this.searchingChurch = true
			let url = this.getApiBackend + 'churchs'
			this.axiosLocal('GET', url, 'getAllChurchsResult')
		},
		getAllChurchsResult(response) {
			this.searchingChurch = false
			if(response.data.success == true) {
				this.listChurchs = response.data.data
			}
		}
	},
}

export default church;